<div class="modal-header">
  <h3 class="modal-title">Alertas do {{$alerta.usuario.nome}}</h3>
</div>
<div class="modal-body">
  <div class="checkbox">
    <label>
      <input type="checkbox" ng-model="$alerta.alertas.boletim"> Boletim de ocorrências com máquinas
    </label>
  </div>

  <div class="checkbox">
    <label>
      <input type="checkbox" ng-model="$alerta.alertas.aplicacoes_que_divergem"> Aplicações que divergem da recomendação
    </label>
  </div>

  <div class="checkbox">
    <label>
      <input type="checkbox" ng-model="$alerta.alertas.tarefas_atrasadas"> Quando houver tarefas em atraso
    </label>
  </div>

  <div class="checkbox">
    <label>
      <input type="checkbox" ng-model="$alerta.alertas.pulverizacoes"> Quando houver pulverizações
    </label>
  </div>

  <div class="checkbox">
    <label>
      <input type="checkbox" ng-model="$alerta.alertas.chuva"> Quando ocorrer chuva
    </label>
  </div>

  <div class="checkbox">
    <label>
      <input type="checkbox" ng-model="$alerta.alertas.boletim_em_atraso"> Quando houver B.O. em atraso
    </label>
  </div>

    <div class="checkbox">
      <label>
        <input type="checkbox" ng-model="$alerta.alertas.glebas_sem_visita"> Dias sem visita aos talhões
      </label>
    </div>
    <input class="form-control" ng-touched ng-model="$alerta.configuracoes.glebas_sem_visita.dias_sem_visita" type="number" id="glebas_sem_visita" placeholder="Dias">
</div>

<div class="modal-footer align-left">
  <div class="col-xs-12 btn-group">
    <button class="btn btn-default btn-sm btn-action" type="button" ng-click="$alerta.close()" ng-disabled="$alerta.saving">Cancelar</button>
    <button class="btn btn-success btn-sm btn-action" type="button" ng-click="$alerta.save(usuario)" ng-disabled="$alerta.saving">
        Salvar <i ng-hide="$alerta.saving" class="fa fa-check"></i>
        <span ng-show="$alerta.saving">
          <i class="fa fa-spinner fa-spin"></i>
        </span>
    </button>
  </div>
</div>
